import React from 'react';
import { useSelector } from 'react-redux';
import Body from './body/Body';
import Footer from './footer/Footer';
import Header from './header/Header';

const Mobile = () => {
    const textures = useSelector(state => state.texture);
    const picState = useSelector(state => state.picture);

    return ( 
        <div className='mobile-container'>
            <div className='header w-100 d-inline-block'>
                <Header/>
            </div>
                <div className='body w-100 d-inline-block css-nkyeax'>
                    <Body Img={picState.img}/>
                </div>
            <div className='footer w-100 d-inline-block'>
                <Footer mainState={textures}/>
            </div>
        </div>
    );
}
 
export default Mobile;